{
  "app.name": "Cargofollow Sign",
  "app.tagline": "Signez et consultez les lettres de voiture sur votre téléphone.",
  "language.label": "Langue",
  "language.nl": "Néerlandais",
  "language.en": "Anglais",
  "language.de": "Allemand",
  "language.fr": "Français",
  "home.title": "Cargofollow Sign",
  "home.body": "Ouvrez cette application avec le lien ou le code QR que l'expéditeur ou le transporteur vous a remis. Sans lien, il n'y a rien à afficher.",
  "route.sign.title": "Signer",
  "route.sign.body": "Le parcours de signature de ce lien se charge ici.",
  "route.inspect.title": "Contrôle",
  "route.inspect.body": "La lettre de voiture liée à ce lien de contrôle s'affiche ici.",
  "route.driver.title": "Conducteur",
  "route.driver.body": "Vos trajets s'affichent ici.",
  "offline.body": "Vous êtes hors ligne. Ce que vous voyez provient du cache de l'application.",
  "error.title": "Une erreur s'est produite",
  "error.body": "Réessayez. Si le problème persiste, demandez un nouveau lien.",
  "error.not_found.title": "Page introuvable",
  "error.not_found.body": "Vérifiez le lien ou le code QR que vous avez reçu.",
  "error.network": "Pas de connexion au serveur.",
  "error.unexpected": "Erreur inattendue.",
  "loading": "Chargement",
  "button.sign": "Signer",
  "button.clear": "Effacer",
  "button.undo": "Annuler la dernière action",
  "button.confirm": "Confirmer",
  "button.cancel": "Annuler",
  "button.retry": "Réessayer",
  "button.open": "Ouvrir",
  "button.view_pdf": "Voir le PDF",
  "status.expired.title": "Lien expiré",
  "status.expired.body": "Ce lien de signature a expiré. Demandez un nouveau lien à l'expéditeur.",
  "status.used.title": "Déjà signé",
  "status.used.body": "Ce lien a déjà été utilisé. Il n'y a plus rien à faire.",
  "status.revoked.title": "Lien retiré",
  "status.revoked.body": "La partie qui a envoyé ce lien l'a retiré. Demandez-lui un nouveau lien.",
  "status.success.title": "Signé",
  "status.success.body": "Merci, {name}. Votre signature a été enregistrée le {timestamp}.",
  "shipment.title": "Lettre de voiture",
  "shipment.reference": "Référence",
  "shipment.consignor": "Expéditeur",
  "shipment.consignee": "Destinataire",
  "shipment.carrier": "Transporteur",
  "shipment.pickup": "Lieu de chargement",
  "shipment.delivery": "Lieu de livraison",
  "shipment.window": "Créneau horaire",
  "shipment.goods": "Marchandises",
  "shipment.goods.none": "Aucune marchandise renseignée.",
  "shipment.transport": "Transport",
  "shipment.vehicle": "Immatriculation",
  "shipment.driver": "Conducteur",
  "shipment.transport_type": "Type de transport",
  "shipment.charges": "Frais",
  "shipment.charges.carriage": "Prix du transport",
  "shipment.special_agreements": "Conventions particulières",
  "shipment.status.draft": "Brouillon",
  "shipment.status.issued": "Émise",
  "shipment.status.in_transit": "En transit",
  "shipment.status.delivered": "Livrée",
  "shipment.status.completed": "Clôturée",
  "shipment.status.cancelled": "Annulée",
  "shipment.transport_type.national": "National",
  "shipment.transport_type.international": "International",
  "shipment.transport_type.cabotage": "Cabotage",
  "shipment.transport_type.combined": "Combiné",
  "package_type.pallet": "palettes",
  "package_type.box": "boîtes",
  "package_type.carton": "cartons",
  "package_type.crate": "caisses",
  "package_type.bag": "sacs",
  "package_type.drum": "fûts",
  "package_type.roll": "rouleaux",
  "package_type.bundle": "bottes",
  "package_type.container": "conteneurs",
  "package_type.loose": "en vrac",
  "package_type.other": "colis",
  "document.kind.ecmr_pdf": "Lettre de voiture",
  "document.kind.pod_pdf": "Preuve de livraison",
  "document.kind.attachment": "Pièce jointe",
  "document.kind.signature_image": "Signature",
  "document.kind.photo": "Photo",
  "document.kind.other": "Document",
  "documents.empty.title": "Aucun document",
  "documents.empty.body": "Dès qu'une lettre de voiture ou une pièce jointe est prête, elle apparaît ici.",
  "timeline.empty.title": "Aucun événement",
  "timeline.empty.body": "L'historique de cet envoi se remplit dès qu'il se passe quelque chose.",
  "event.shipment.created": "Envoi créé",
  "event.shipment.issued": "Lettre de voiture émise",
  "event.shipment.updated": "Envoi modifié",
  "event.shipment.cancelled": "Envoi annulé",
  "event.shipment.pickup_signed": "Signé au chargement",
  "event.shipment.delivered": "Livré",
  "event.shipment.completed": "Expédition clôturée",
  "event.signature.completed": "Signature enregistrée",
  "event.document.created": "Document ajouté",
  "event.remark.added": "Observation ajoutée",
  "event.inspection.viewed": "Contrôle consulté",
  "event.provider.sync_failed": "Échec de la synchronisation",
  "event.efti.uil_issued": "UIL eFTI émis",
  "event.efti.authority_access": "Consulté par une autorité",
  "event.efti.combined_transport_stamped": "Cachet transport combiné",
  "actor.api_key": "Clé API",
  "actor.user": "Utilisateur",
  "actor.signer": "Signataire",
  "actor.provider": "Plateforme",
  "actor.system": "Système",
  "actor.public": "Lien public",
  "actor.authority": "Autorité",
  "signature.hint": "Signez dans le cadre.",
  "signature.ready": "Signature enregistrée.",
  "sign.role.consignor": "Expéditeur",
  "sign.role.carrier": "Transporteur",
  "sign.role.consignee": "Destinataire",
  "sign.intro": "Vous signez cette lettre de voiture en tant que {role}.",
  "sign.expires": "Ce lien est valable jusqu'au {timestamp}.",
  "sign.documents.title": "Documents",
  "sign.signatures.title": "Déjà signé",
  "sign.signatures.none": "Personne n'a encore signé.",
  "sign.signatures.entry": "{name} · {timestamp}",
  "sign.start": "Continuer vers la signature",
  "sign.step.title": "Votre signature",
  "sign.field.name": "Nom",
  "sign.field.name.error": "Indiquez votre nom.",
  "sign.field.company": "Société",
  "sign.field.company.hint": "Facultatif.",
  "sign.field.signature": "Signature",
  "sign.field.signature.error": "Signez d'abord dans le cadre.",
  "sign.signature.too_large": "La signature dépasse la limite de taille. Effacez-la et signez plus simplement.",
  "sign.consent.label": "Je signe cette lettre de voiture par voie électronique et j'accepte les conditions eCMR.",
  "sign.consent.error": "Acceptez les conditions avant de signer.",
  "sign.geo.label": "Partager ma position avec cette signature",
  "sign.geo.pending": "Récupération de la position…",
  "sign.geo.captured": "Position enregistrée.",
  "sign.geo.denied": "Aucune position disponible. Vous pouvez signer malgré tout.",
  "sign.submit": "Signer",
  "sign.submitting": "Envoi en cours",
  "sign.back": "Retour à la lettre de voiture",
  "sign.success.signed_as": "Signé en tant que {role}",
  "sign.success.consignee_note": "La preuve de livraison suivra plus tard. Il n'y a plus rien à faire sur ce lien.",
  "sign.success.no_pdf": "Aucun PDF n'est encore disponible.",
  "sign.method.title": "Comment souhaitez-vous signer ?",
  "sign.method.intro": "Vous signez cette lettre de voiture en tant que {role}. Choisissez comment.",
  "sign.method.drawn.title": "Signer à l'écran",
  "sign.method.drawn.body": "Tracez votre signature avec le doigt.",
  "sign.method.click_otp.title": "Confirmer avec un code",
  "sign.method.click_otp.body": "Vous recevez un code à six chiffres et confirmez d'une seule pression.",
  "sign.otp.title": "Confirmer avec un code",
  "sign.otp.intro": "Indiquez votre nom, acceptez, et nous vous enverrons un code à six chiffres.",
  "sign.otp.channel.label": "Où envoyer le code ?",
  "sign.otp.channel.email": "Par e-mail",
  "sign.otp.channel.sms": "Par SMS",
  "sign.otp.send": "Envoyer le code",
  "sign.otp.sending": "Envoi du code",
  "sign.otp.code.title": "Saisissez le code",
  "sign.otp.sent": "Nous avons envoyé un code à {destination}.",
  "sign.otp.code.label": "Code à six chiffres",
  "sign.otp.code.hint": "Le code est valable dix minutes.",
  "sign.otp.code.error": "Saisissez les six chiffres.",
  "sign.otp.resend": "Envoyer un nouveau code",
  "sign.otp.resend.wait": "Nouveau code dans {seconds} secondes",
  "sign.otp.confirm": "Confirmer et signer",
  "sign.otp.confirming": "Confirmation en cours",
  "sign.otp.error.invalid": "Ce code est incorrect. Vérifiez le message et réessayez.",
  "sign.otp.error.locked": "Trop de codes erronés. Demandez un nouveau code dans quelques minutes.",
  "sign.otp.error.expired": "Ce code a expiré. Demandez-en un nouveau.",
  "sign.otp.error.rate_limited": "Trop de codes ont été demandés. Patientez un instant et réessayez.",
  "sign.otp.error.send": "Le code n'a pas pu être envoyé. Réessayez ou signez à l'écran.",
  "sign.otp.error.unavailable": "Ce lien ne comporte ni adresse e-mail ni numéro de téléphone pour un code. Signez à l'écran.",
  "pickup.title": "Chargement et signature",
  "pickup.intro": "L'expéditeur et le transporteur signent cette lettre de voiture ensemble au chargement.",
  "pickup.parties.title": "Signatures",
  "pickup.party.signed": "Signé par {name} le {timestamp}.",
  "pickup.party.signed_elsewhere": "Signé sur un autre appareil.",
  "pickup.party.signed_name": "Signé par {name}.",
  "pickup.party.queued": "Signé par {name}, pas encore envoyé. Cela se fera tout seul dès que vous serez de nouveau en ligne.",
  "pickup.party.queued_stopped": "Signé par {name}, mais pas envoyé. Consultez la file d'attente.",
  "pickup.party.waiting": "Pas encore signé.",
  "pickup.party.no_link": "Aucun lien de signature n'a été créé pour ce rôle.",
  "pickup.party.link_used": "Ce lien de signature a déjà été utilisé.",
  "pickup.party.link_expired": "Ce lien de signature a expiré.",
  "pickup.party.link_revoked": "Ce lien de signature a été retiré.",
  "pickup.action.sign_here": "Signer ici",
  "pickup.action.own_device": "Sur son propre appareil",
  "pickup.handoff.title": "Sur son propre appareil : {role}",
  "pickup.handoff.body": "Faites scanner ce code QR par le signataire. Le lien fonctionne une seule fois et reste valable dix minutes.",
  "pickup.handoff.qr_alt": "Code QR vers le lien de signature",
  "pickup.handoff.open": "Ouvrir le lien",
  "pickup.handoff.expires": "Valable jusqu'au {timestamp}.",
  "pickup.handoff.waiting": "En attente de la signature…",
  "pickup.handoff.creating": "Création du code QR",
  "pickup.handoff.failed": "Le code QR n'a pas pu être créé.",
  "pickup.handoff.back": "Retour à l'aperçu",
  "pickup.queued.back": "Retour à l'aperçu",
  "pickup.done.title": "Signé au chargement",
  "pickup.done.body": "L'expéditeur et le transporteur ont tous deux signé.",
  "pickup.done.status": "Statut de l'envoi : {status}",
  "pickup.done.signature": "{role} : {name} · {timestamp}",
  "pickup.unusable.title": "Pas une session de chargement",
  "pickup.unusable.body": "Ce lien ne concerne pas le chargement. Ouvrez le lien que vous avez reçu de l'expéditeur ou du transporteur.",
  "delivery.title": "Livraison",
  "delivery.intro": "Vérifiez les colis, signalez les réserves et faites signer le destinataire.",
  "delivery.step": "Étape {current} sur {total}",
  "delivery.back": "Retour",
  "delivery.colli.title": "Vérifier les colis",
  "delivery.colli.body": "Indiquez pour chaque ligne de marchandises le nombre de colis reçus.",
  "delivery.colli.expected": "Attendu : {count} {package_type}",
  "delivery.colli.received": "Reçus",
  "delivery.colli.error": "Saisissez un nombre supérieur ou égal à 0.",
  "delivery.colli.empty": "Cette lettre de voiture ne comporte aucune ligne de marchandises.",
  "delivery.colli.total": "Total : {received} colis sur {expected}.",
  "delivery.colli.line": "{description} : {received} reçus sur {expected}.",
  "delivery.colli.match": "Les quantités correspondent.",
  "delivery.colli.shortage": "Il manque {count, plural, one {# colis} other {# colis}}. Signalez-le comme réserve.",
  "delivery.colli.surplus": "Il y a {count, plural, one {# colis} other {# colis}} en trop. Signalez-le comme réserve.",
  "delivery.remark.title": "Réserves",
  "delivery.remark.body": "Signalez un dommage, un manquant ou un retard sur cette livraison.",
  "delivery.remark.required": "Les quantités diffèrent, inscrivez donc une réserve.",
  "delivery.remark.type": "Type de réserve",
  "delivery.remark.type.damage": "Dommage",
  "delivery.remark.type.shortage": "Manquant",
  "delivery.remark.type.delay": "Retard",
  "delivery.remark.type.other": "Autre",
  "delivery.remark.text": "Description",
  "delivery.remark.text.hint": "Décrivez brièvement le problème.",
  "delivery.remark.text.error": "Décrivez la réserve.",
  "delivery.remark.photos": "Photos",
  "delivery.remark.photos.hint": "Au maximum {max} photos. Les grandes photos sont réduites avant l’envoi.",
  "delivery.remark.photos.add": "Ajouter une photo",
  "delivery.remark.photos.full": "Vous pouvez joindre au maximum {max} photos.",
  "delivery.remark.photo.alt": "Photo {number}",
  "delivery.remark.photo.compressing": "Réduction…",
  "delivery.remark.photo.uploading": "Envoi… {percent} %",
  "delivery.remark.photo.stored": "Envoyée · {size}",
  "delivery.remark.photo.failed": "Échec de l’envoi.",
  "delivery.remark.photo.unreadable": "Cette photo est illisible.",
  "delivery.remark.photo.retry": "Renvoyer",
  "delivery.remark.photo.remove": "Supprimer",
  "delivery.remark.photo.waiting": "Attendez que les photos soient envoyées.",
  "delivery.remark.submit": "Enregistrer la réserve",
  "delivery.remark.submitting": "Enregistrement",
  "delivery.remark.skip": "Aucune réserve",
  "delivery.remark.failed": "La réserve n’a pas pu être enregistrée. Réessayez.",
  "delivery.device.title": "Qui signe et où ?",
  "delivery.device.body": "Le destinataire signe sur votre appareil, ou sur le sien via un code QR.",
  "delivery.device.driver": "Le destinataire signe ici",
  "delivery.device.driver.hint": "Sur votre appareil. Cela est consigné avec la signature.",
  "delivery.device.own": "Sur son propre appareil",
  "delivery.device.own.hint": "Le destinataire scanne un code QR et signe sur son propre téléphone.",
  "delivery.handoff.back": "Retour au choix",
  "delivery.done.title": "Livré",
  "delivery.done.body": "La lettre de voiture a été signée à la livraison.",
  "delivery.done.status": "Statut de l’envoi : {status}",
  "delivery.done.signed": "Signé par {name} le {timestamp}.",
  "delivery.done.signed_elsewhere": "Signé sur l’appareil du destinataire.",
  "delivery.done.device.driver": "Signé sur l’appareil du conducteur.",
  "delivery.done.device.own": "Signé sur l’appareil du destinataire.",
  "delivery.pod.title": "Preuve de livraison",
  "delivery.pod.colli": "Colis : {received} reçus sur {expected}.",
  "delivery.pod.colli.unknown": "Colis : non comptés sur cet appareil.",
  "delivery.pod.remarks.none": "Aucune réserve signalée.",
  "delivery.pod.remark": "{type} : {text}",
  "delivery.pod.remark.untyped": "{type}",
  "delivery.pod.remark.photos": "{count, plural, one {# photo} other {# photos}}",
  "delivery.pod.download": "Télécharger la preuve de livraison",
  "delivery.pod.pdf": "Preuve de livraison (PDF)",
  "delivery.pod.pdf.pending": "Le PDF de la preuve de livraison n’est pas encore prêt.",
  "fixtures.title": "Composants",
  "fixtures.shipment": "ShipmentView",
  "fixtures.timeline": "Timeline",
  "fixtures.documents": "DocumentList",
  "fixtures.signature": "SignaturePad",
  "fixtures.signature.export": "Exporter en PNG",
  "fixtures.signature.exported": "PNG de {width}×{height} px, {bytes} octets.",
  "fixtures.signature.empty": "Rien de dessiné pour le moment.",
  "shipment.not_provided": "Non renseigné",
  "shipment.box": "Case {number}",
  "shipment.goods.table": "Marchandises (cases 6 à 12)",
  "shipment.driver.hidden": "Les coordonnées du conducteur ne sont pas affichées.",
  "shipment.driver.phone": "Téléphone du conducteur",
  "shipment.signature.method": "Méthode",
  "shipment.signature.trust": "Niveau de confiance",
  "shipment.signature.qtsp": "Service de confiance",
  "shipment.signature.hash": "Empreinte de la version",
  "shipment.signature.verified": "Correspond à la version actuelle",
  "shipment.signature.superseded": "Signé sur une version antérieure",
  "shipment.signature.method.drawn": "Signature à l'écran",
  "shipment.signature.method.click_otp": "Confirmation par code à usage unique",
  "shipment.signature.method.api": "Via l'API du système",
  "shipment.signature.method.photo_of_paper": "Photo d'une signature sur papier",
  "shipment.signature.trust.platform_auth": "Authentification de la plateforme",
  "shipment.signature.trust.ades": "Avancée (AdES)",
  "shipment.signature.trust.qes": "Qualifiée (QES)",
  "inspect.title": "Lettre de voiture",
  "inspect.subtitle": "Consultation en lecture seule via le code QR de la lettre de voiture.",
  "inspect.version": "Version {version}",
  "inspect.viewed_at": "Consultée le {timestamp}",
  "inspect.expires": "Ce lien de contrôle est valable jusqu'au {timestamp}.",
  "inspect.integrity.ok.title": "Chaîne intacte",
  "inspect.integrity.ok.body": "{events} événements, sans rupture depuis la création.",
  "inspect.integrity.broken.title": "Chaîne rompue",
  "inspect.integrity.broken.body": "Les événements de cet envoi ne correspondent pas à leur chaîne d'empreintes. Contactez le transporteur.",
  "inspect.integrity.head_hash": "Empreinte de tête",
  "inspect.documents.title": "Documents",
  "inspect.pdf.download": "Télécharger la lettre de voiture (PDF)",
  "inspect.pdf.none": "Aucun PDF de cette lettre de voiture n'est encore disponible.",
  "inspect.print": "Imprimer",
  "inspect.expired.title": "Lien de contrôle expiré",
  "inspect.expired.body": "Ce lien de contrôle a expiré. Demandez au transporteur un code QR à jour.",
  "inspect.rotated.title": "Lien de contrôle remplacé",
  "inspect.rotated.body": "Ce lien de contrôle a été remplacé. Scannez le code QR de la lettre de voiture actuelle.",
  "inspect.not_found.title": "Lien de contrôle inconnu",
  "inspect.not_found.body": "Vérifiez le code QR sur la lettre de voiture.",
  "driver.title": "Se connecter en tant que chauffeur",
  "driver.intro": "Saisis le numéro de téléphone que ton planificateur a indiqué sur l'expédition. Tu recevras un code par SMS.",
  "driver.country.label": "Pays",
  "driver.phone.label": "Numéro de téléphone",
  "driver.phone.hint": "Sans l'indicatif du pays ; nous ajoutons {prefix} devant.",
  "driver.error.phone_invalid": "Ce numéro de téléphone ne semble pas valide.",
  "driver.button.send_code": "Envoyez-moi un code",
  "driver.code.title": "Saisis le code",
  "driver.code.body": "Nous avons envoyé un code à six chiffres au {phone}.",
  "driver.code.label": "Code",
  "driver.code.hint": "Six chiffres, valable dix minutes.",
  "driver.button.verify": "Se connecter",
  "driver.button.change_number": "Utiliser un autre numéro",
  "driver.error.code_invalid": "Ce code est incorrect ou expiré. Demandes-en un nouveau.",
  "driver.error.locked": "Trop de tentatives. Attends quelques minutes puis demande un nouveau code.",
  "driver.error.session_expired": "Ta session a expiré. Reconnecte-toi.",
  "driver.list.title": "Tes trajets",
  "driver.sandbox.title": "Environnement de test",
  "driver.sandbox.body": "Ce numéro n'apparaît que sur des envois d'essai. Ce que tu vois ici n'est pas un vrai trajet.",
  "driver.button.sign_out": "Se déconnecter",
  "driver.button.refresh": "Actualiser",
  "driver.empty.title": "Rien en cours",
  "driver.empty.body": "Aucun trajet en cours sur ce numéro. Si ce n'est pas normal, demande à ton planificateur d'indiquer ton numéro sur l'expédition.",
  "driver.action.load": "Charger",
  "driver.action.deliver": "Décharger",
  "driver.reference.none": "Sans référence",
  "driver.ordered_by": "Pour le compte de {party}",
  "driver.window.none": "Aucun créneau convenu",
  "driver.then.deliver": "Ensuite décharger chez {party} à {city}.",
  "driver.then.loaded": "Chargé chez {party} à {city}.",
  "driver.signed_off": "Déjà signé.",
  "driver.button.open_pickup": "Charger et signer",
  "driver.button.open_delivery": "Livrer et faire signer",
  "driver.button.navigate": "Naviguer",
  "driver.tour.untitled": "Tournée sans nom",
  "driver.tour.progress": "{done} arrêts sur {total}",
  "driver.tour.loose": "Courses isolées",
  "driver.tour.stop.numbered": "Arrêt {position} · {action}",
  "driver.tour.stop.done": "Signé",
  "driver.tour.stop.waiting": "Pas encore votre tour",
  "driver.tour.stop.closed": "N'est plus ouvert",
  "queue.title": "File d'attente",
  "queue.body": "Ces envois attendent sur cet appareil. Ils partent d'eux-mêmes dès qu'une connexion est de nouveau disponible.",
  "queue.badge": "{count} en file d'attente",
  "queue.empty.title": "Rien en file d'attente",
  "queue.empty.body": "Tout ce que vous avez enregistré a été envoyé.",
  "queue.kind.photo": "Photo",
  "queue.kind.remark": "Réserve",
  "queue.kind.signature": "Signature",
  "queue.state.pending": "En attente de connexion",
  "queue.state.sending": "En cours d'envoi",
  "queue.state.conflict": "Traité ailleurs",
  "queue.state.failed": "Non envoyé",
  "queue.captured": "Enregistré à {timestamp}",
  "queue.hash": "Empreinte du contenu {hash}",
  "queue.attempts": "Tentatives : {count}",
  "queue.reason.queue_blocked": "Non envoyé : un envoi antérieur de la même course est resté bloqué.",
  "queue.reason.hash_mismatch": "Non envoyé : le contenu stocké ne correspond pas à l'empreinte prise au moment de l'enregistrement.",
  "queue.reason.already_signed": "Cette lettre de voiture a entre-temps été signée sur un autre appareil. Cet envoi n'est plus nécessaire.",
  "queue.reason.link_expired": "Le lien a expiré avant que cet envoi ait pu partir.",
  "queue.reason.network": "Le serveur était injoignable. Vous pouvez réessayer.",
  "queue.reason.refused": "Le serveur a refusé cet envoi ({code}).",
  "queue.retry": "Réessayer",
  "queue.discard": "Supprimer",
  "queue.offline": "Pas de connexion. La file attend que vous soyez de nouveau en ligne.",
  "queue.done.title": "Enregistré, pas encore envoyé",
  "queue.done.body": "Vous n'avez pas de connexion. Ce que vous avez enregistré est en sécurité sur cet appareil et partira de lui-même dès que vous serez de nouveau en ligne.",
  "queue.done.status": "Sera envoyé dès que vous serez en ligne",
  "queue.done.open": "Voir la file d'attente",
  "delivery.remark.photo.queued": "En file d'attente, envoyé dès que vous serez en ligne",
  "sign.identification.title": "Identifiez-vous d'abord",
  "sign.identification.intro": "Cette lettre de voiture demande {level}. Identifiez-vous auprès de {provider} ; ensuite vous signez comme d'habitude.",
  "sign.identification.why": "Le service de confiance établit qui vous êtes, puis signe exactement cette version de la lettre de voiture.",
  "sign.identification.start": "S'identifier auprès de {provider}",
  "sign.identification.retry": "Réessayer",
  "sign.identification.waiting": "Identification en cours",
  "sign.identification.waiting.body": "Nous attendons que {provider} confirme votre identification. Cet écran continue tout seul.",
  "sign.identification.level.ades": "une signature avancée (AdES)",
  "sign.identification.level.qes": "une signature qualifiée (QES)"
}
